<template>
  <div>
    <loadingCube v-if="!stats_loaded" :loadingMessage="'NOTE STATS'"></loadingCube>

    <div v-else class="row stats_page">
      <div class="col-12">
        <div>
          <b-tabs content-class="mt-3" justified pills>
            <b-tab title="DAILY NOTE STATS" active>
              <div class="row mb-3">
                <div class="col-12">
                  <hr class="mt-2">
                  <h2 class="bp_color font-weight-bold">DAILY NOTE STATS</h2>
                  <p>Below is a breakdown of all notes left in the CRM for the day. Refreshing this tab will update the stats to include every note left up until this page
                    loads.</p>
                </div>
              </div>

              <div class="row sparkBoxes">
                <div class="col-lg-3 col-md-6">
                  <div class="box">
                    <h3 class="pl-2 pt-2 mb-0 text-uppercase">COMPANY SALES NOTES</h3>
                    <h5 class="pl-2 pt-1 text-uppercase bp_color">TOTAL : {{ note_stats.all_note_stats.sales_company.total_day }}</h5>
                    <div class="box_chart">
                      <apexchart type="pie" :options="daily_charts.sales_company.options" :series="daily_charts.sales_company.data"></apexchart>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="box">
                    <h3 class="pl-2 pt-2 mb-0 text-uppercase">COMPANY SERVICE NOTES</h3>
                    <h5 class="pl-2 pt-1 text-uppercase bp_color">TOTAL : {{ note_stats.all_note_stats.service_company.total_day }}</h5>
                    <div class="box_chart">
                      <apexchart type="pie" :options="daily_charts.service_company.options" :series="daily_charts.service_company.data"></apexchart>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="box">
                    <h3 class="pl-2 pt-2 mb-0 text-uppercase">WORKER SALES NOTES</h3>
                    <h5 class="pl-2 pt-1 text-uppercase bp_color">TOTAL : {{ note_stats.all_note_stats.sales_worker.total_day }}</h5>
                    <div class="box_chart">
                      <apexchart type="pie" :options="daily_charts.sales_worker.options" :series="daily_charts.sales_worker.data"></apexchart>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="box">
                    <h3 class="pl-2 pt-2 mb-0 text-uppercase">WORKER SERVICE NOTES</h3>
                    <h5 class="pl-2 pt-1 text-uppercase bp_color">TOTAL : {{ note_stats.all_note_stats.service_worker.total_day }}</h5>
                    <div class="box_chart">
                      <apexchart type="pie" :options="daily_charts.service_worker.options" :series="daily_charts.service_worker.data"></apexchart>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-12 mt-3">
                  <table class="table table-striped table-sm">
                    <thead>
                    <tr>
                      <th colspan="1"></th>
                      <th colspan="6" class="text-center table_section">COMPANY SALES NOTES</th>
                      <th colspan="3" class="text-center table_section">WORKER SALES NOTES</th>
                      <th colspan="4" class="text-center table_section">COMPANY SERVICE NOTES</th>
                      <th colspan="4" class="text-center table_section">WORKER SERVICE NOTES</th>
                    </tr>
                    <tr class="second_header">
                      <th class="name">Name</th>
                      <!-- COMPANY SALES NOTES -->
                      <th class="text-center table_section_start">Total Notes</th>
                      <th class="text-center">Total Calls</th>
                      <th class="text-center">Connected (In/Out)</th>
                      <th class="text-center">Connected DM Calls</th>
                      <th class="text-center">Emails</th>
                      <th class="text-center">Meetings<br>(Booked/Held &&nbsp;Drop&nbsp;In's)</th>
                      <!-- WORKER SALES NOTES -->
                      <th class="text-center table_section_start">Total Notes</th>
                      <th class="text-center">Total Calls</th>
                      <th class="text-center">Connected (In/Out)</th>
                      <!-- COMPANY SERVICE NOTES -->
                      <th class="text-center table_section_start">Total Notes</th>
                      <th class="text-center">Total Calls</th>
                      <th class="text-center">Connected (In/Out)</th>
                      <th class="text-center">Meetings<br>(Booked/Held &&nbsp;Drop&nbsp;In's)</th>
                      <!-- WORKER SERVICE NOTES -->
                      <th class="text-center table_section_start">Total Notes</th>
                      <th class="text-center">Total Calls</th>
                      <th class="text-center">Connected (In/Out)</th>
                      <th class="text-center">Tax (Discussed/Sold)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(stats, user) in note_stats.day_stats" class="stats_row">
                      <td class="">{{ user }}</td>
                      <!-- COMPANY SALES NOTES -->
                      <td class="table_section_start text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_company.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_company.calls.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.calls.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_company.calls.connected.incoming`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.calls.connected.incoming }}</button>
                        /
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_company.calls.connected.outgoing`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.calls.connected.outgoing }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_company.calls.connected.decision_maker`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.calls.connected.decision_maker }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_company.emails`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.emails }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_company.meetings.booked`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.meetings.booked }}</button>
                        \
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_company.meetings.held`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.meetings.held }}</button>
                        \
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_company.meetings.drop_in`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.meetings.drop_in }}</button>
                      </td>
                      <!-- WORKER SALES NOTES -->
                      <td class="table_section_start text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_worker.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_worker.calls.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_worker.calls.connected.incoming`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.connected.incoming }}</button>
                        \
                        <button @click="view_notes_list_modal(`day_stats.${user}.sales_worker.calls.connected.outgoing`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.connected.outgoing }}</button>
                      </td>
                      <!-- COMPANY SERVICE NOTES -->
                      <td class="table_section_start text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_company.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_company.calls.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.calls.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_company.calls.connected.incoming`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.calls.connected.incoming }}</button>
                        \
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_company.calls.connected.outgoing`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.calls.connected.outgoing }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_company.meetings.booked`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.meetings.booked }}</button>
                        \
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_company.meetings.held`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.meetings.held }}</button>
                        \
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_company.meetings.drop_in`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.meetings.drop_in }}</button>
                      </td>
                      <!-- WORKER SERVICE NOTES -->
                      <td class="table_section_start text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_worker.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_worker.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_worker.calls.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_worker.calls.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_worker.calls.connected.incoming`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_worker.calls.connected.incoming }}</button>
                        /
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_worker.calls.connected.outgoing`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_worker.calls.connected.outgoing }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_worker.calls.connected.tax_discussed`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.connected.tax_discussed + stats.service_worker.calls.connected.tax_discussed }}</button>
                        /
                        <button @click="view_notes_list_modal(`day_stats.${user}.service_worker.calls.connected.tax_sold`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.connected.tax_sold + stats.service_worker.calls.connected.tax_sold }}</button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-tab>
            <b-tab title="WEEKLY NOTE STATS">
              <div class="row mb-3">
                <div class="col-12">
                  <hr class="mt-2">
                  <h2 class="bp_color font-weight-bold">WEEKLY NOTE STATS</h2>
                  <p>Below is a breakdown of all notes left in the CRM for the week. Refreshing this tab will update the stats to include every note left up until this page
                    loads.</p>
                </div>
              </div>

              <div class="row sparkBoxes">
                <div class="col-lg-3 col-md-6">
                  <div class="box">
                    <h3 class="pl-2 pt-2 mb-0 text-uppercase">COMPANY SALES NOTES</h3>
                    <h5 class="pl-2 pt-1 text-uppercase bp_color">TOTAL : {{ note_stats.all_note_stats.sales_company.total_week }}</h5>
                    <div class="box_chart">
                      <apexchart type="pie" :options="weekly_charts.sales_company.options" :series="weekly_charts.sales_company.data"></apexchart>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="box">
                    <h3 class="pl-2 pt-2 mb-0 text-uppercase">COMPANY SERVICE NOTES</h3>
                    <h5 class="pl-2 pt-1 text-uppercase bp_color">TOTAL : {{ note_stats.all_note_stats.service_company.total_week }}</h5>
                    <div class="box_chart">
                      <apexchart type="pie" :options="weekly_charts.service_company.options" :series="weekly_charts.service_company.data"></apexchart>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="box">
                    <h3 class="pl-2 pt-2 mb-0 text-uppercase">WORKER SALES NOTES</h3>
                    <h5 class="pl-2 pt-1 text-uppercase bp_color">TOTAL : {{ note_stats.all_note_stats.sales_worker.total_week }}</h5>
                    <div class="box_chart">
                      <apexchart type="pie" :options="weekly_charts.sales_worker.options" :series="weekly_charts.sales_worker.data"></apexchart>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="box">
                    <h3 class="pl-2 pt-2 mb-0 text-uppercase">WORKER SERVICE NOTES</h3>
                    <h5 class="pl-2 pt-1 text-uppercase bp_color">TOTAL : {{ note_stats.all_note_stats.service_worker.total_week }}</h5>
                    <div class="box_chart">
                      <apexchart type="pie" :options="weekly_charts.service_worker.options" :series="weekly_charts.service_worker.data"></apexchart>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-12 mt-3">
                  <table class="table table-striped table-sm">
                    <thead>
                    <tr>
                      <th colspan="1"></th>
                      <th colspan="6" class="text-center table_section">COMPANY SALES NOTES</th>
                      <th colspan="3" class="text-center table_section">WORKER SALES NOTES</th>
                      <th colspan="4" class="text-center table_section">COMPANY SERVICE NOTES</th>
                      <th colspan="4" class="text-center table_section">WORKER SERVICE NOTES</th>
                    </tr>
                    <tr class="second_header">
                      <th class="name">Name</th>
                      <!-- COMPANY SALES NOTES -->
                      <th class="text-center table_section_start">Total Notes</th>
                      <th class="text-center">Total Calls</th>
                      <th class="text-center">Connected (In/Out)</th>
                      <th class="text-center">Connected DM Calls</th>
                      <th class="text-center">Emails</th>
                      <th class="text-center">Meetings<br>(Booked/Held &&nbsp;Drop&nbsp;In's)</th>
                      <!-- WORKER SALES NOTES -->
                      <th class="text-center table_section_start">Total Notes</th>
                      <th class="text-center">Total Calls</th>
                      <th class="text-center">Connected (In/Out)</th>
                      <!-- COMPANY SERVICE NOTES -->
                      <th class="text-center table_section_start">Total Notes</th>
                      <th class="text-center">Total Calls</th>
                      <th class="text-center">Connected (In/Out)</th>
                      <th class="text-center">Meetings<br>(Booked/Held &&nbsp;Drop&nbsp;In's)</th>
                      <!-- WORKER SERVICE NOTES -->
                      <th class="text-center table_section_start">Total Notes</th>
                      <th class="text-center">Total Calls</th>
                      <th class="text-center">Connected (In/Out)</th>
                      <th class="text-center">Tax (Discussed/Sold)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(stats, user) in note_stats.week_stats" class="stats_row">
                      <td class="">{{ user }}</td>
                      <!-- COMPANY SALES NOTES -->
                      <td class="table_section_start text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_company.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_company.calls.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.calls.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_company.calls.connected.incoming`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.calls.connected.incoming }}</button>
                        /
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_company.calls.connected.outgoing`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.calls.connected.outgoing }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_company.calls.connected.decision_maker`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.calls.connected.decision_maker }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_company.emails`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.emails }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_company.meetings.booked`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.meetings.booked }}</button>
                        \
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_company.meetings.held`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.meetings.held }}</button>
                        \
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_company.meetings.drop_in`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.meetings.drop_in }}</button>
                      </td>
                      <!-- WORKER SALES NOTES -->
                      <td class="table_section_start text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_worker.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_worker.calls.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_worker.calls.connected.incoming`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.connected.incoming }}</button>
                        \
                        <button @click="view_notes_list_modal(`week_stats.${user}.sales_worker.calls.connected.outgoing`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.connected.outgoing }}</button>
                      </td>
                      <!-- COMPANY SERVICE NOTES -->
                      <td class="table_section_start text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_company.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_company.calls.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.calls.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_company.calls.connected.incoming`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.calls.connected.incoming }}</button>
                        \
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_company.calls.connected.outgoing`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.calls.connected.outgoing }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_company.meetings.booked`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.meetings.booked }}</button>
                        \
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_company.meetings.held`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.meetings.held }}</button>
                        \
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_company.meetings.drop_in`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.meetings.drop_in }}</button>
                      </td>
                      <!-- WORKER SERVICE NOTES -->
                      <td class="table_section_start text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_worker.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_worker.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_worker.calls.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_worker.calls.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_worker.calls.connected.incoming`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_worker.calls.connected.incoming }}</button>
                        /
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_worker.calls.connected.outgoing`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_worker.calls.connected.outgoing }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_worker.calls.connected.tax_discussed`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.connected.tax_discussed + stats.service_worker.calls.connected.tax_discussed }}</button>
                        /
                        <button @click="view_notes_list_modal(`week_stats.${user}.service_worker.calls.connected.tax_sold`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.connected.tax_sold + stats.service_worker.calls.connected.tax_sold }}</button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-tab>
            <b-tab title="MONTHLY NOTE STATS">
              <div class="row mb-3">
                <div class="col-12">
                  <hr class="mt-2">
                  <h2 class="bp_color font-weight-bold">MONTHLY NOTE STATS</h2>
                  <p>Below is a breakdown of all notes left in the CRM for the month. Refreshing this tab will update the stats to include every note left up until this page
                    loads.</p>
                </div>
              </div>

              <div class="row sparkBoxes">
                <div class="col-lg-3 col-md-6">
                  <div class="box">
                    <h3 class="pl-2 pt-2 mb-0 text-uppercase">COMPANY SALES NOTES</h3>
                    <h5 class="pl-2 pt-1 text-uppercase bp_color">TOTAL : {{ note_stats.all_note_stats.sales_company.total_month }}</h5>
                    <div class="box_chart">
                      <apexchart type="pie" :options="monthly_charts.sales_company.options" :series="monthly_charts.sales_company.data"></apexchart>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="box">
                    <h3 class="pl-2 pt-2 mb-0 text-uppercase">COMPANY SERVICE NOTES</h3>
                    <h5 class="pl-2 pt-1 text-uppercase bp_color">TOTAL : {{ note_stats.all_note_stats.service_company.total_month }}</h5>
                    <div class="box_chart">
                      <apexchart type="pie" :options="monthly_charts.service_company.options" :series="monthly_charts.service_company.data"></apexchart>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="box">
                    <h3 class="pl-2 pt-2 mb-0 text-uppercase">WORKER SALES NOTES</h3>
                    <h5 class="pl-2 pt-1 text-uppercase bp_color">TOTAL : {{ note_stats.all_note_stats.sales_worker.total_month }}</h5>
                    <div class="box_chart">
                      <apexchart type="pie" :options="monthly_charts.sales_worker.options" :series="monthly_charts.sales_worker.data"></apexchart>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="box">
                    <h3 class="pl-2 pt-2 mb-0 text-uppercase">WORKER SERVICE NOTES</h3>
                    <h5 class="pl-2 pt-1 text-uppercase bp_color">TOTAL : {{ note_stats.all_note_stats.service_worker.total_month }}</h5>
                    <div class="box_chart">
                      <apexchart type="pie" :options="monthly_charts.service_worker.options" :series="monthly_charts.service_worker.data"></apexchart>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-12 mt-3">
                  <table class="table table-striped table-sm">
                    <thead>
                    <tr>
                      <th colspan="1"></th>
                      <th colspan="6" class="text-center table_section">COMPANY SALES NOTES</th>
                      <th colspan="3" class="text-center table_section">WORKER SALES NOTES</th>
                      <th colspan="4" class="text-center table_section">COMPANY SERVICE NOTES</th>
                      <th colspan="4" class="text-center table_section">WORKER SERVICE NOTES</th>
                    </tr>
                    <tr class="second_header">
                      <th class="name">Name</th>
                      <!-- COMPANY SALES NOTES -->
                      <th class="text-center table_section_start">Total Notes</th>
                      <th class="text-center">Total Calls</th>
                      <th class="text-center">Connected (In/Out)</th>
                      <th class="text-center">Connected DM Calls</th>
                      <th class="text-center">Emails</th>
                      <th class="text-center">Meetings<br>(Booked/Held &&nbsp;Drop&nbsp;In's)</th>
                      <!-- WORKER SALES NOTES -->
                      <th class="text-center table_section_start">Total Notes</th>
                      <th class="text-center">Total Calls</th>
                      <th class="text-center">Connected (In/Out)</th>
                      <!-- COMPANY SERVICE NOTES -->
                      <th class="text-center table_section_start">Total Notes</th>
                      <th class="text-center">Total Calls</th>
                      <th class="text-center">Connected (In/Out)</th>
                      <th class="text-center">Meetings<br>(Booked/Held &&nbsp;Drop&nbsp;In's)</th>
                      <!-- WORKER SERVICE NOTES -->
                      <th class="text-center table_section_start">Total Notes</th>
                      <th class="text-center">Total Calls</th>
                      <th class="text-center">Connected (In/Out)</th>
                      <th class="text-center">Tax (Discussed/Sold)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(stats, user) in note_stats.month_stats" class="stats_row">
                      <td class="">{{ user }}</td>
                      <!-- COMPANY SALES NOTES -->
                      <td class="table_section_start text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_company.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_company.calls.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.calls.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_company.calls.connected.incoming`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.calls.connected.incoming }}</button>
                        /
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_company.calls.connected.outgoing`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.calls.connected.outgoing }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_company.calls.connected.decision_maker`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.calls.connected.decision_maker }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_company.emails`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.emails }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_company.meetings.booked`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.meetings.booked }}</button>
                        \
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_company.meetings.held`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.meetings.held }}</button>
                        \
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_company.meetings.drop_in`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_company.meetings.drop_in }}</button>
                      </td>
                      <!-- WORKER SALES NOTES -->
                      <td class="table_section_start text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_worker.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_worker.calls.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_worker.calls.connected.incoming`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.connected.incoming }}</button>
                        \
                        <button @click="view_notes_list_modal(`month_stats.${user}.sales_worker.calls.connected.outgoing`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.connected.outgoing }}</button>
                      </td>
                      <!-- COMPANY SERVICE NOTES -->
                      <td class="table_section_start text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_company.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_company.calls.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.calls.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_company.calls.connected.incoming`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.calls.connected.incoming }}</button>
                        \
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_company.calls.connected.outgoing`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.calls.connected.outgoing }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_company.meetings.booked`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.meetings.booked }}</button>
                        \
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_company.meetings.held`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.meetings.held }}</button>
                        \
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_company.meetings.drop_in`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_company.meetings.drop_in }}</button>
                      </td>
                      <!-- WORKER SERVICE NOTES -->
                      <td class="table_section_start text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_worker.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_worker.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_worker.calls.total`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_worker.calls.total }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_worker.calls.connected.incoming`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_worker.calls.connected.incoming }}</button>
                        /
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_worker.calls.connected.outgoing`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.service_worker.calls.connected.outgoing }}</button>
                      </td>
                      <td class="text-center">
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_worker.calls.connected.tax_discussed`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.connected.tax_discussed + stats.service_worker.calls.connected.tax_discussed }}</button>
                        /
                        <button @click="view_notes_list_modal(`month_stats.${user}.service_worker.calls.connected.tax_sold`)" class="btn btn-sm" data-toggle="tooltip" title="View Notes">{{ stats.sales_worker.calls.connected.tax_sold + stats.service_worker.calls.connected.tax_sold }}</button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue';

Vue.use(VueApexCharts)

export default {
  name: "crm_note_stats",
  components: {
    loadingCube,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      stats_loaded: false,
      note_stats: {},

      daily_charts: {
        sales_company: {
          data: [],
          total: 0,
          options: {
            labels: [],
            stroke: {colors: ['transparent']},
            fill: {opacity: 0.8},
            legend: {
              position: 'bottom',
            }
          },
        },
        service_company: {
          data: [],
          total: 0,
          options: {
            labels: [],
            stroke: {colors: ['transparent']},
            fill: {opacity: 0.8},
            legend: {
              position: 'bottom',
            }
          },
        },
        sales_worker: {
          data: [],
          total: 0,
          options: {
            labels: [],
            stroke: {colors: ['transparent']},
            fill: {opacity: 0.8},
            legend: {
              position: 'bottom',
            }
          },
        },
        service_worker: {
          data: [],
          total: 0,
          options: {
            labels: [],
            stroke: {colors: ['transparent']},
            fill: {opacity: 0.8},
            legend: {
              position: 'bottom',
            }
          },
        },
      },
      weekly_charts: {
        sales_company: {
          data: [],
          total: 0,
          options: {
            labels: [],
            stroke: {colors: ['transparent']},
            fill: {opacity: 0.8},
            legend: {
              position: 'bottom',
            }
          },
        },
        service_company: {
          data: [],
          total: 0,
          options: {
            labels: [],
            stroke: {colors: ['transparent']},
            fill: {opacity: 0.8},
            legend: {
              position: 'bottom',
            }
          },
        },
        sales_worker: {
          data: [],
          total: 0,
          options: {
            labels: [],
            stroke: {colors: ['transparent']},
            fill: {opacity: 0.8},
            legend: {
              position: 'bottom',
            }
          },
        },
        service_worker: {
          data: [],
          total: 0,
          options: {
            labels: [],
            stroke: {colors: ['transparent']},
            fill: {opacity: 0.8},
            legend: {
              position: 'bottom',
            }
          },
        },
      },
      monthly_charts: {
        sales_company: {
          data: [],
          total: 0,
          options: {
            labels: [],
            stroke: {colors: ['transparent']},
            fill: {opacity: 0.8},
            legend: {
              position: 'bottom',
            }
          },
        },
        service_company: {
          data: [],
          total: 0,
          options: {
            labels: [],
            stroke: {colors: ['transparent']},
            fill: {opacity: 0.8},
            legend: {
              position: 'bottom',
            }
          },
        },
        sales_worker: {
          data: [],
          total: 0,
          options: {
            labels: [],
            stroke: {colors: ['transparent']},
            fill: {opacity: 0.8},
            legend: {
              position: 'bottom',
            }
          },
        },
        service_worker: {
          data: [],
          total: 0,
          options: {
            labels: [],
            stroke: {colors: ['transparent']},
            fill: {opacity: 0.8},
            legend: {
              position: 'bottom',
            }
          },
        },
      },
    }
  },
  mounted() {
    this.get_stats().then(() => this.stats_loaded = true)
  },
  methods: {
    get_stats() {
      return axios.get(this.crmApiPath + 'crm/reports/note_stats').then(stats => {
        this.note_stats = stats.data
        // sales company chart
        for (let i = 0; i < stats.data.all_note_stats.sales_company.note_totals.length; i++) {
          let legend_label = stats.data.all_note_stats.sales_company.note_totals[i].ident
              .replace('sales_company_', '')
              .replaceAll('_', ' ')
              .replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
          this.daily_charts.sales_company.options.labels.push(legend_label)
          this.weekly_charts.sales_company.options.labels.push(legend_label)
          this.monthly_charts.sales_company.options.labels.push(legend_label)
          this.daily_charts.sales_company.data.push(stats.data.all_note_stats.sales_company.note_totals[i].day_total)
          this.weekly_charts.sales_company.data.push(stats.data.all_note_stats.sales_company.note_totals[i].week_total)
          this.monthly_charts.sales_company.data.push(stats.data.all_note_stats.sales_company.note_totals[i].month_total)
        }
        // service company_chart
        for (let i = 0; i < stats.data.all_note_stats.service_company.note_totals.length; i++) {
          let legend_label = stats.data.all_note_stats.service_company.note_totals[i].ident
              .replace('service_company_', '')
              .replaceAll('_', ' ')
              .replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
          this.daily_charts.service_company.options.labels.push(legend_label)
          this.weekly_charts.service_company.options.labels.push(legend_label)
          this.monthly_charts.service_company.options.labels.push(legend_label)
          this.daily_charts.service_company.data.push(stats.data.all_note_stats.service_company.note_totals[i].day_total)
          this.weekly_charts.service_company.data.push(stats.data.all_note_stats.service_company.note_totals[i].week_total)
          this.monthly_charts.service_company.data.push(stats.data.all_note_stats.service_company.note_totals[i].month_total)
        }
        // sales worker_chart
        for (let i = 0; i < stats.data.all_note_stats.sales_worker.note_totals.length; i++) {
          let legend_label = stats.data.all_note_stats.sales_worker.note_totals[i].ident
              .replace('sales_worker_', '')
              .replaceAll('_', ' ')
              .replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
          this.daily_charts.sales_worker.options.labels.push(legend_label)
          this.weekly_charts.sales_worker.options.labels.push(legend_label)
          this.monthly_charts.sales_worker.options.labels.push(legend_label)
          this.daily_charts.sales_worker.data.push(stats.data.all_note_stats.sales_worker.note_totals[i].day_total)
          this.weekly_charts.sales_worker.data.push(stats.data.all_note_stats.sales_worker.note_totals[i].week_total)
          this.monthly_charts.sales_worker.data.push(stats.data.all_note_stats.sales_worker.note_totals[i].month_total)
        }
        // service worker_chart
        for (let i = 0; i < stats.data.all_note_stats.service_worker.note_totals.length; i++) {
          let legend_label = stats.data.all_note_stats.service_worker.note_totals[i].ident
              .replace('service_worker_', '')
              .replaceAll('_', ' ')
              .replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
          this.daily_charts.service_worker.options.labels.push(legend_label)
          this.weekly_charts.service_worker.options.labels.push(legend_label)
          this.monthly_charts.service_worker.options.labels.push(legend_label)
          this.daily_charts.service_worker.data.push(stats.data.all_note_stats.service_worker.note_totals[i].day_total)
          this.weekly_charts.service_worker.data.push(stats.data.all_note_stats.service_worker.note_totals[i].week_total)
          this.monthly_charts.service_worker.data.push(stats.data.all_note_stats.service_worker.note_totals[i].month_total)
        }
      });
    },
    view_notes_list_modal(note_id) {
      this.$store.commit('SHOW_VIEW_NOTES_LIST_MODAL', {
        id: note_id,
        name: this.full_name,
        type: 'worker',
        contacts: null
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_notes_list_modal'));
    },
  }
}
</script>

<style lang="scss">
.stats_page {
  .nav-pills {
    .nav-link {
      text-transform: uppercase;
      color:          $bc_3;
      font-weight:    bold;
      padding:        0.4rem 1rem;

      &:hover, {
        outline:          none;
        cursor:           pointer;
        color:            $white;
        background-color: darken($bc_1, 25%);
        border-color:     darken($bc_1, 25%);
        box-shadow:       0 4px 5px 0 rgba($black, 0.14), 0 1px 10px 0 rgba($black, 0.12), 0 2px 4px -1px rgba($black, 0.3);
      }

      &.disabled {
        background: lighten($bc_5, 10%);
      }
    }

    .nav-item {

    }
  }

  .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    background-color: $bc_1;
    border-color:     $bc_1;
    box-shadow:       0 4px 5px 0 rgba($black, 0.14), 0 1px 10px 0 rgba($black, 0.12), 0 2px 4px -1px rgba($black, 0.3);
    color:            $white;
  }

  .sparkBoxes {
    .box {
      position:         relative;
      box-shadow:       0 1px 22px -12px #607D8B;
      background-color: #fff;
      padding:          10px;
      margin-bottom:    20px;

      .box_chart {
        max-width: 550px;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  table {
    .table_section {
      font-size:   1rem;
      color:       $bc_1;
      font-weight: bold;
      border-left: 1px solid red;
    }

    .table_section_start {
      border-left: 1px solid red;
    }

    .second_header {
      font-size: 0.65rem;
    }

    .stats_row {
      td {
        vertical-align: middle
      }
    }
  }
}
</style>
